var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldRender
    ? _c(
        "div",
        { staticClass: "atendimento-popup" },
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shouldShowPopup,
                  expression: "shouldShowPopup"
                }
              ],
              staticClass: "atendimento-popup__fab az-shadow",
              style: { zIndex: _vm.zIndex },
              attrs: {
                fab: "",
                color: "primary",
                "data-test": "atendimento-popup-fab",
                "aria-label": _vm.toggleAriaLabel,
                "aria-expanded": _vm.isOpen ? "true" : "false"
              },
              on: { click: _vm.toggle }
            },
            [
              _c("icon-svg", {
                attrs: {
                  name: _vm.isOpen ? "close" : "messages-2",
                  size: _vm.isOpen ? "26" : "32",
                  color: "#FFFFFF"
                }
              })
            ],
            1
          ),
          _c("transition", { attrs: { name: "fade-scale" } }, [
            _vm.isOpen && _vm.shouldShowPopup
              ? _c(
                  "div",
                  {
                    staticClass:
                      "atendimento-popup__panel az-card rounded-sm no-padding",
                    style: Object.assign({}, _vm.panelCssVars, {
                      zIndex: _vm.zIndex
                    }),
                    attrs: { "data-test": "atendimento-popup-panel" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "atendimento-popup__header d-flex align-center px-4"
                      },
                      [
                        _vm.hasSelectedConversa
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  "data-test": "atendimento-popup-back",
                                  "aria-label": "Voltar para a lista"
                                },
                                on: { click: _vm.voltarParaLista }
                              },
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: "mdi-arrow-left",
                                    size: "18",
                                    color: "#8E8E8E"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass:
                              "az-text-primary az-size-14 font-medium flex-grow-1"
                          },
                          [
                            _vm._v(" Mensagens "),
                            _vm.syncingChats
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-progress-circular",
                                                _vm._g(
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      indeterminate: "",
                                                      size: "12",
                                                      width: "2",
                                                      color: "primary",
                                                      "data-test":
                                                        "popup-sync-indicator"
                                                    }
                                                  },
                                                  on
                                                )
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4275137222
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        " Sincronizando conversas recentes do WhatsApp. Isso pode levar alguns segundos. "
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm.canOpenFullAtendimento
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  "data-test":
                                                    "atendimento-popup-expand",
                                                  "aria-label":
                                                    "Expandir mensagens"
                                                },
                                                on: {
                                                  click: _vm.openFullAtendimento
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c("icon-svg", {
                                                attrs: {
                                                  name: "mdi-open-in-new",
                                                  size: "16",
                                                  color: "#8E8E8E"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1825822877
                                )
                              },
                              [
                                _c("span", [
                                  _vm._v("Abrir atendimento completo")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _c("icon-svg", {
                          attrs: {
                            name: "messages-2",
                            size: "16",
                            color: "primary"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "atendimento-popup__body" },
                      [
                        !_vm.hasSelectedConversa
                          ? _c("ConversationList", {
                              staticClass: "atendimento-popup__list",
                              attrs: {
                                conexoes: _vm.conexoes,
                                refreshing: _vm.refreshingChats,
                                panelStyle: "flatWhite",
                                "empty-state-rich": ""
                              },
                              on: {
                                select: _vm.onSelectConversa,
                                "conexao-updated": _vm.reloadConexoes,
                                "refresh-chats-list":
                                  _vm.onRefreshChatsListFromList
                              }
                            })
                          : _c(
                              "div",
                              { staticClass: "atendimento-popup__chat" },
                              [
                                _c("ChatWindow", {
                                  attrs: {
                                    conexoes: _vm.conexoes,
                                    "has-conexoes": _vm.hasConexoes,
                                    "show-close-conversa": false
                                  },
                                  on: { "import-history": _vm.onImportHistory }
                                })
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ]),
          _c("ModalNovaConversa"),
          _c("ModalImportarHistorico"),
          _c("ModalGerenciarRespostas"),
          _c("ModalRespostaRapida"),
          _c("ModalTransferirConversa"),
          _c("ModalVincularContato")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }